import type { OTCDealData } from '@src/types/OTC';
import { CopyCsv, CopyJson, Divider, ShowJson } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';

export function RepoGridRowMenu(
  params: ICellRendererParams & {
    onShowJson(data: OTCDealData): void;
  }
) {
  return (
    <>
      <ShowJson {...params} />
      <Divider orientation="horizontal" />
      <CopyJson {...params} />
      <CopyCsv {...params} />
    </>
  );
}
